<template>
    <div class="row">
        <div class="col text-right">
            <button
                class="btn btn-primary"
                :disabled="isDisabled"
                :class="{ 'transparent' : !isShown }"
                @click="onClick">
                <Icon
                    type="button-arrow"
                    :height="16"
                    :width="9" />
                {{ label }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { scrollToNewElement } from '@/services/scrollToService';
import iframeService from '@/services/iframeService';

export default {
    name: 'SectionEndButton',
    props: {
        isDisabled: {
            type: Boolean,
            required: true,
            default: false,
        },
        isShown: {
            type: Boolean,
            required: true,
            default: false,
        },
        label: {
            type: String,
            required: true,
            default: '',
        },
        nextSection: {
            type: Object,
            required: true,
            default: null,
        },
    },
    methods: {
        ...mapActions(['addOpenSection']),
        onClick () {
            if (iframeService.isAppIframed()) {
                iframeService.setIframeIsResizing(); // set flag to delay scrolling until iframe is resized
            }
            this.addOpenSection(this.nextSection);
            this.scrollToNextSection(this.nextSection);

            this.$emit('click');
        },
        scrollToNextSection (nextSection) {
            this.$nextTick(() => {
                scrollToNewElement(`.${nextSection.cssClassName}`);
            });
        },
    },
};
</script>

<style scoped lang="scss">
  .btn {
    margin-top: 20px;
    transition: opacity 1s;

    @include media-breakpoint-down(xs) {
      margin-top: 15px;
    }
  }

  .transparent {
    opacity: 0;
    pointer-events: none;
  }
</style>
